








































import Vue, { PropType } from 'vue';

import { SectionStatus } from '@/utilities/dynamic-document';

/**
 * The fixed onderbalk: one tab per section, its icon green once nothing in the section is open and
 * red while something is, above the Afronden button.
 *
 * The tabs are styled to the installation screen's module nav (`.top-nav`) but are NOT `v-tabs`.
 * That component is a selector built on `v-slide-group`, which reserves a 52px arrow affix on the
 * left and scrolls its overflow by transform — reachable only through those arrows or a touch
 * swipe. With seven sections the strip always overflows a phone, so it has to scroll natively.
 */
export default Vue.extend({
  props: {
    sections: {
      type: Array as PropType<SectionStatus[]>,
      default: () => [],
    },

    finished: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    /** Anchor of the section currently on screen; its tab is kept in view. */
    activeAnchor: {
      type: String,
      default: '',
    },
  },

  watch: {
    activeAnchor: 'revealTab',
  },

  methods: {
    /**
     * Slide the strip so the section being worked on sits in the middle of it. Centring rather than
     * merely bringing it into view is the point: it keeps a neighbour showing on either side, so
     * the tabs off the right edge are visibly there rather than something to discover.
     */
    revealTab(anchor: string) {
      const nav = this.$refs.nav as HTMLElement | undefined;
      const index = this.sections.findIndex(section => section.anchor === anchor);
      const tab = (this.$refs.tabs as HTMLElement[] | undefined)?.[index];

      if (!nav || !tab) {
        return;
      }

      const navBox = nav.getBoundingClientRect();
      const tabBox = tab.getBoundingClientRect();
      const left = Math.max(
        0,
        nav.scrollLeft + (tabBox.left - navBox.left) - (nav.clientWidth - tabBox.width) / 2,
      );

      if (typeof nav.scrollTo === 'function') {
        nav.scrollTo({ left, behavior: 'smooth' });
      } else {
        nav.scrollLeft = left;
      }
    },
  },
});
